import React from 'react';
import { Table } from 'reactstrap';
import StickyTable from '../../../hoc/StickyTable';
import WithHover from '../../../hoc/WithHover';

const View = ({ stats, renderTableFields, renderStats, renderEmptyData }) => {
  return (
    <StickyTable>
      <Table
        tag={WithHover}
        className="statistics-table conversion-table sticky-table inverse"
        responsive
        striped
        hover
      >
        <thead>
          <tr className="table-fields">{renderTableFields()}</tr>
        </thead>
        <tbody>{stats.length > 0 ? renderStats() : renderEmptyData()}</tbody>
      </Table>
    </StickyTable>
  );
};

export default View;
